import Heading from 'components/Heading'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

const MoreInfoContent = ({ showContainerNotes = true }) => {
  const { t } = useTranslation()

  return (
    <div>
      <div className="logbook-and-container-notes__more-info-content">
        <Heading hasNoMarginBottom isDark level={4}>
          {t('portCall.logbookAndContainerNotes.logbook')}
        </Heading>
        <Text>
          {t('portCall.logbookAndContainerNotes.moreInfoContent.addedByShip')}
        </Text>
        <Text>
          {t(
            'portCall.logbookAndContainerNotes.moreInfoContent.includedInReport'
          )}
        </Text>
        <Text>
          {t(
            'portCall.logbookAndContainerNotes.moreInfoContent.anyoneWhoHasPinned'
          )}
        </Text>
      </div>

      {showContainerNotes && (
        <div className="logbook-and-container-notes__more-info-content--container-notes">
          <Heading hasNoMarginBottom isDark level={4}>
            {t('portCall.logbookAndContainerNotes.containerNotebook')}
          </Heading>
          <Text>
            {t(
              'portCall.logbookAndContainerNotes.moreInfoContent.containerNotesAddedByShip'
            )}
          </Text>
          <Text>
            {t(
              'portCall.logbookAndContainerNotes.moreInfoContent.containerNotesCrewCanRecord'
            )}
          </Text>
          <Text>
            {t(
              'portCall.logbookAndContainerNotes.moreInfoContent.containerNotesVisible'
            )}
          </Text>
        </div>
      )}

      <div className="logbook-and-container-notes__more-info-content--cut-container">
        <Heading hasNoMarginBottom isDark level={4}>
          {t('portCall.logbookAndContainerNotes.cutContainer')}
        </Heading>
        <Text>
          {t(
            'portCall.logbookAndContainerNotes.moreInfoContent.cutContainerCancelledByShip'
          )}
        </Text>
        <Text>
          {t(
            'portCall.logbookAndContainerNotes.moreInfoContent.cutContainerNotLoaded'
          )}
        </Text>
        <Text>
          {t(
            'portCall.logbookAndContainerNotes.moreInfoContent.cutContainerVisible'
          )}
        </Text>
      </div>
    </div>
  )
}

MoreInfoContent.propTypes = {
  showContainerNotes: PropTypes.bool,
}

export default MoreInfoContent
